
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private activeCount = 0;
  readonly isVisible$ = new BehaviorSubject<boolean>(false);
  delayMs = 0;

  start() {
    this.activeCount++;
    // Show immediately when first request starts
    if (this.activeCount === 1) {
      console.debug('[LoadingService] SHOW overlay (activeCount=1)');
      this.isVisible$.next(true);
    } else {
      console.debug('[LoadingService] Increment activeCount=', this.activeCount);
    }
  }

  stop() {
    if (this.activeCount === 0) return;
    this.activeCount--;

    console.debug('[LoadingService] Decrement activeCount=', this.activeCount);

    if (this.activeCount === 0) {
      // Hide immediately when all requests complete
      console.debug('[LoadingService] HIDE overlay (activeCount=0)');
      this.isVisible$.next(false);
    }
  }

  // setters in case revert to delayed behavior later
  setDelay(ms: number) { this.delayMs = ms; }
}
